import React, { memo, useCallback } from "react";
import stylesPc from "./VideoSuggestion.module.css";
import stylesSp from "./VideoSuggestion_SP.module.css";
import { IsDevice } from "../../../../components/function/useDeviceFlag";
import { Link, useHistory } from "react-router-dom";
//import PresenterIcon from "../../../../common/components/icons/PresenterIcon";
import PuiTypography from "../../../../components/elements/PuiTypography";
import PuiTooltip from "../../../../components/elements/PuiTooltip ";

interface VideoSuggestionProps {
    video: any;
}

function VideoSuggestion({ video }: VideoSuggestionProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const history = useHistory();
    const goToVideo = useCallback(() => history.push(`/video/${video.id}`), [video, history]);
    return (
        <>
            {video && (
                <div className={styles.root} onClick={goToVideo}>
                    <img
                        className={styles.thumbnail}
                        src={video.imageUrl}
                        alt=""
                        onError={(e) =>
                            (e.currentTarget.src = require("../../../../assets/image/NoImage.jpg"))
                        }
                    />

                    {/* 新規ビデオアイコン */}
                    {video.visibleNewIcon && (
                        <img
                            src={require("../../../../assets/image/newIcon.svg")}
                            className={styles.newIcon}
                            alt={`newIcon_${video.id}`}
                        />
                    )}
                    <div className={styles.text}>
                        <div className={styles.textUpper}>
                            <div className={styles.title} data-tip={video.title} data-for="title">
                                <Link to={`/video/${video.id}`}>
                                    <PuiTypography>{video.title}</PuiTypography>
                                </Link>
                            </div>
                            <PuiTooltip id="title" />
                            {/* <div className={styles.presenter}>
                        <div className={styles.presenterIcon}>
                            <PresenterIcon color="grey-42"/>
                        </div>

                        <PuiTypography size={14} color="gray-61">{video.presenter}</PuiTypography>
                    </div> */}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default memo(VideoSuggestion);
